import React from "react";
import { PageHeader } from "antd";
import EditableParameterTable from "./components/editable-parameter-table";
import { DISPLAY_MODE } from "Constants";

export default function GeneralParameter({
  title,
  api,
  subUnit,
  ItemsComponent,
  columnsExtended,
  authSubject,
  editableCode,
  mode = DISPLAY_MODE.EDIT,
  ...props
}) {
  return (
    <>
      <PageHeader title={title} />
      <div style={{ margin: "0 24px" }}>
        <EditableParameterTable
          api={api}
          title={title}
          authSubject={authSubject}
          ItemsComponent={ItemsComponent}
          columnsExtended={columnsExtended}
          editableCode={editableCode}
          mode={mode}
        />
      </div>
    </>
  );
}
